export default __webpack_public_path__ + "static/media/crown.959726ed.png";